// Version-info visas i Inställningar → Om appen.
// - APP_VERSION uppdateras manuellt när nya versioner släpps.
// - BUILD_DATE sätts automatiskt vid varje `yarn build` via craco.config.js
//   (falls tillbaka till dagens datum i utvecklingsläge så det aldrig blir tomt).
// - BUILD_SHA injiceras via REACT_APP_BUILD_SHA om satt under CI, annars "dev".
export const APP_VERSION = "1.13.3";
export const BUILD_DATE =
  process.env.REACT_APP_BUILD_DATE || new Date().toISOString().split("T")[0];
export const BUILD_SHA = (process.env.REACT_APP_BUILD_SHA || "dev").slice(0, 7);
